import { useEffect, useState } from "react";
import { getUserToken } from "./authFunctions";

/**
 * Reads the logged-in staff member's cognito:groups off the already-fetched session token
 * (the same claim validateAuthentication checks for "admin" at login, just not persisted
 * anywhere reusable today). Used for finer-grained, per-feature gating beyond the single
 * "admin" boolean the rest of this app relies on.
 * @returns {{ groups: string[], loading: boolean, hasGroup: (name: string) => boolean }}
 */
export function useAdminGroups() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getUserToken()
      .then((tokens) => {
        const raw = tokens?.idToken?.payload?.["cognito:groups"];
        const list = Array.isArray(raw) ? raw : typeof raw === "string" ? [raw] : [];
        if (active) setGroups(list);
      })
      .catch(() => {
        if (active) setGroups([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const hasGroup = (name) => groups.includes(name);

  return { groups, loading, hasGroup };
}
